/* global Sentry */
import 'react-app-polyfill/ie11'; // For IE11 support
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faInfoCircle,
  faPencilAlt,
  faExternalLinkAlt,
  faCheck,
  faCheckCircle,
  faTerminal,
  faLongArrowAltLeft,
  faSearch,
  faExclamationTriangle,
  faSignOutAlt,
  faUpload,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { faPaperPlane, faLightbulb, faTrashAlt, faMeh } from '@fortawesome/free-regular-svg-icons';

import Root from './scripts/modules/Root';
import './styles/styles.css';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://0cf3c3511d6b4b02ab8c7456618cc543@sentry.io/201115',
    release: `${process.env.REACT_APP_RELEASE_NUMBER}`,
    integrations: [
      new Sentry.Integrations.Dedupe(),
      new Sentry.Integrations.ExtraErrorData()
    ]
  });
}

library.add(
  faUser,
  faInfoCircle,
  faPencilAlt,
  faExternalLinkAlt,
  faCheck,
  faCheckCircle,
  faTerminal,
  faLongArrowAltLeft,
  faSearch,
  faExclamationTriangle,
  faSignOutAlt,
  faUpload,
  faPlus,

  faPaperPlane,
  faLightbulb,
  faTrashAlt,
  faMeh
);

ReactDOM.render(<Root />, document.getElementById('root'));
